export type Language = 'de' | 'en' | 'es' | 'fr' | 'it';

export const extractLanguageCode = (locale: string): Language => {
  const [language = ''] = locale.split(/[-_]/);

  return language.toLowerCase() as Language;
};
